import { jsxs as d, jsx as t } from "@emotion/react/jsx-runtime";
import { AvatarContainer as u, StyledTextAvatar as s, BubbleContainer as h, IconContainer as A } from "./Avatar.styled.js";
import { Icon as C } from "../Icon/index.js";
import { Image as v } from "../Image/index.js";
const y = (r) => r ? r.length <= 3 ? r.toUpperCase() : r.charAt(0).toUpperCase() : "", b = ({
  shape: r = "default",
  position: c = "bottom-right",
  image: n,
  bubble: e = null,
  size: o = 50,
  text: i,
  backgroundColor: a,
  textColor: l,
  textSize: f = 18,
  iconSize: m,
  border: p = !0
}) => /* @__PURE__ */ d(u, { size: o, shape: r, border: p, children: [
  i ? /* @__PURE__ */ t(s, { shape: r, backgroundColor: a, textColor: l, textSize: f, children: y(i) }) : /* @__PURE__ */ t(() => typeof n == "string" ? /* @__PURE__ */ t(v, { src: n ?? "", alt: "", width: o, height: o, style: {
    borderRadius: `${r === "default" ? "50%" : "0"}`,
    position: "absolute",
    top: 0,
    left: 0
  } }) : /* @__PURE__ */ t(A, { shape: r, backgroundColor: a, children: /* @__PURE__ */ t(C, { icon: n, color: l, iconSize: m }) }), {}),
  !!e && /* @__PURE__ */ t(h, { size: o, position: c, children: e })
] });
export {
  b as Avatar
};
